export default __webpack_public_path__ + "static/media/brazil_flag.a212bb3f.svg";